import React, { useEffect, useState } from 'react';
import WATemplateDetail from './WATemplateDetail';
import CreateWATemplate from './CreateWATemplate';
import { fetchWATemplates } from '../services/watemplateService';
import { MultiSelectDropdown } from '../components/MultiSelectDropdown';

const WATemplate = () => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [creating, setCreating] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  // For input fields
  const [tempChannels, setTempChannels] = useState([]);
  const [tempSearchName, setTempSearchName] = useState('');


  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTemplates = templates.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(templates.length / itemsPerPage);

  const loadTemplates = async (channels = [], search = '') => {
    setLoading(true);
    const result = await fetchWATemplates({
      channels: channels.map((c) => c.id),
      search,
    });
    setTemplates(result);
    setLoading(false);
    setCurrentPage(1);
  };

  useEffect(() => {
    // Initial load
    loadTemplates();
  }, []);

  const handleApplyFilters = () => {
    loadTemplates(tempChannels, tempSearchName);
  };

  const handleClearFilters = () => {
    setTempChannels([]);
    setTempSearchName('');
    loadTemplates([], '');
  };

  const handleRowClick = (template) => {
    setSelectedTemplate(template);
  };

  const handleBack = () => {
    setSelectedTemplate(null);
    setCreating(false);
  };

  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  return (
    <div className="p-4">
      {!selectedTemplate && !creating ? (
        <>
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">WA Templates</h2>
          </div>

          <div className="flex items-end">
            <button
              onClick={() => setCreating(true)}
              className="bg-green-600 text-white px-4 py-2 my-2 rounded hover:bg-green-700"
            >
              + Create WA Template
            </button>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap gap-4 items-end my-4">
            <MultiSelectDropdown
              label="Channel"
              options={[{ id: 'whatsapp', name: 'WhatsApp' }]}
              selected={tempChannels}
              setSelected={setTempChannels}
            />
            <input
              type="text"
              placeholder="Search by template name"
              className="border px-3 py-2 rounded min-w-[200px]"
              value={tempSearchName}
              onChange={(e) => setTempSearchName(e.target.value)}
            />
            <button
              onClick={handleApplyFilters}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Apply Filters
            </button>
            <button
              onClick={handleClearFilters}
              className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
            >
              Clear Filters
            </button>
          </div>

          {/* Template Table */}
          <table className="min-w-full table-auto border">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="px-4 py-2 border">Name</th>
                <th className="px-4 py-2 border">Channel</th>
                <th className="px-4 py-2 border">Template ID</th>
                <th className="px-4 py-2 border">Template Name</th>
                <th className="px-4 py-2 border">Active</th>
              </tr>
            </thead>
            <tbody>
              {currentTemplates.map((template) => (
                <tr
                  key={template.id}
                  className="hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleRowClick(template)}
                >
                  <td className="px-4 py-2 border">{template.name}</td>
                  <td className="px-4 py-2 border">{template.channel}</td>
                  <td className="px-4 py-2 border">{template.template_id}</td>
                  <td className="px-4 py-2 border">{template.template_name}</td>
                  <td className={`px-4 py-2 border font-semibold flex items-center space-x-2 ${template.active ? "text-green-600" : "text-red-600"
                    }`}>
                    <span>
                      {template.active ? "✅ Active" : "❌ Inactive"}
                    </span>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="mt-4 flex gap-2 items-center">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-600 text-white' : ''}`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </>
      ) : creating ? (
        <CreateWATemplate onBack={handleBack} />
      ) : (
        <WATemplateDetail template={selectedTemplate} onBack={handleBack} />
      )}
    </div>
  );
};

export default WATemplate;
